// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__24iZ0","title":"landing_title__12R6u","name":"landing_name___mtb7","description":"landing_description__2FD-b","homeButton":"landing_homeButton__2RFwP"};